const routes = {
  CreateUser: '/Users/add',
  getUsers: '/users',
  updateUser: 'users/update',
  getProfile:'users/profile',
  updateUserStatus: 'users/disable',
  getUserPermissions: 'users/permissions',
  UpdatePassword:'/auth/changePassword',
  getSubUsers:'/customers/users',
  CreateSubUser:'/customers/users/add',
  CreateEmployee:'/hrms/employees/add',
  UpdateEmployee:'/hrms/employees/update',
  CreateSalary:'/hrms/payroll/add',
  UpdateSalary:'/hrms/payroll/update',
  CreateEos:'hrms/eos/add',
  UpdateEOS:'hrms/eos/update',
  BulkDownload:''
  
};

export default routes